import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Button from 'react-bootstrap/Button';
import { BrowserRouter, Route,Router, Switch,Link } from 'react-router-dom'

export default class Contact extends Component {

    constructor(props){
        super(props);
    }

    render() {
        return (
            <div>
            <h2>If you encounter a bug open up an <a href="https://github.com/bthompson7/usaquake/issues">issue on GitHub</a> and use the "bug" label so it's easy to see</h2>
           </div>
        )
    }      
}